import React from 'react';
import '../../styles/library.scss';
import ShortString from '../../../../common-components/ShortString/ShortString';
import { useNavigate } from 'react-router-dom';

const LibraryItem = ({ library }) => {
  const navigate = useNavigate();

  return (
    <div
      className="sl-library-item-container"
      onClick={() => navigate(`/dashboard/social/libraries/${library._id}`, { state: library })}>
      <div className="sl-library-item-images-container">
        <div className="sl-library-item-image-container">
          <ImageItem thumbnail={library?.topPosts[0]?.thumbnail} />
        </div>
        <div className="sl-library-item-images-right-container">
          <div className="sl-library-item-image-container">
            <ImageItem thumbnail={library?.topPosts[1]?.thumbnail} />
          </div>
          <div className="sl-library-item-image-container">
            <ImageItem thumbnail={library?.topPosts[2]?.thumbnail} />
          </div>
        </div>
      </div>
      <div className="sl-library-bottom-container">
        <div className="sl-library-item-title">
          <ShortString name={library.title} stringLength={40} />
        </div>
        <div className="sl-library-item-total-posts">{library.totalPosts}</div>
      </div>
    </div>
  );
};

const ImageItem = ({ thumbnail }) => {
  if (!thumbnail) return <></>;

  return <img src={thumbnail} alt="" width="100%" />;
};

export default LibraryItem;
